import React from 'react'
import { instanceOf } from 'prop-types'
import Box from '@material-ui/core/Box'
// import IconOpenArrow from '../../shared/icons/IconOpenArrow'
import IconTarget from '../../shared/icons/IconTarget'

const TargetLabelHeader = ({ selectedTargets }) => {
  const targetName = selectedTargets ?
    selectedTargets.name : '';
  const targetStudy = selectedTargets ?
  selectedTargets.study : '';
  return (
    <div className="de--label-table-header">
      <div className="de--label-table-header-titleBox">
        <IconTarget
          size={22}
          fill="#ffffff"
        />
        <Box alignItems="center" marginLeft={1} width="95%">
          <div className="de--label-table-header-title" title={targetName}>{targetName}</div>
          <div className="de--label-table-header-study" title={targetStudy}>{targetStudy}</div>
        </Box>
      </div>
      {/* <div className="de--label-table-header-expand">
        <IconOpenArrow />
      </div> */}
    </div>
  )
}

TargetLabelHeader.propTypes = {
  selectedTargets: instanceOf(Object),
}

export default TargetLabelHeader